/* eslint-disable @typescript-eslint/no-unused-vars */
'use client'
import * as React from 'react'

import { useSearchParams } from 'next/navigation'
import { useSession } from 'next-auth/react'

import { signInMicrosoft } from './sign-in-microsoft'

export function UserAuthForm({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  const { status } = useSession()
  const searchParams = useSearchParams()
  const [hasSignedIn, setHasSignedIn] = React.useState(false)

  React.useEffect(() => {
    if (status === 'unauthenticated' && !hasSignedIn) {
      const callbackUrl = searchParams.get('callbackUrl')
      setHasSignedIn(true)
      signInMicrosoft(callbackUrl || undefined)
    }
  }, [status, searchParams, hasSignedIn])

  return <div>&nbsp;</div>
}
